import { api } from '../../utils/apiConfig';
const root = '/api/v2/moments-assistant';
export const sessionRequest = (path, body = {}, csrf) => api.post(`${root}/${path}`, body, { timeout: 10000, headers: { 'X-Moments-Request': '1', ...(csrf ? {'X-Moments-CSRF':csrf} : {}) } });
export async function revokePrivateSession(userId) {
 try {
  const {data} = await sessionRequest('status', {userId});
  await sessionRequest('logout', {}, data.csrf);
 } catch(e) {
  if(e.response?.status===401 && e.response?.data?.csrf) {
   await sessionRequest('logout', {}, e.response.data.csrf);
   return;
  }
  if(e.response?.status===401 || e.response?.data?.code==='SESSION_DISABLED')return;
  throw e;
 }
}
